import React from 'react'

export default () => <a href="mailto:care@myhealthchecked.com">care@myhealthchecked.com</a>
